// extracted by mini-css-extract-plugin
module.exports = {"form":"form-module--form--2eodP","toast":"form-module--toast--30pen","error":"form-module--error--3wXu9","success":"form-module--success--3RtwG"};